<template>
  <div class="node_add">
    <el-form
      :model="node.elForm"
      :rules="node.rules"
      ref="addAlterForm"
      class="el_from"
    >
      <el-form-item label="模块标记" prop="modelSign">
        <el-select
          v-model="node.elForm.modelSign"
          placeholder="请选择内容"
          clearable
        >
          <el-option
            v-for="item in dictData.modelSignLsit"
            :key="item.infoCode"
            :label="item.infoName"
            :value="item.infoCode"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="数据类型" prop="dataType">
        <el-select
          v-model="node.elForm.dataType"
          placeholder="请选择内容"
          @change="dataTypeChange"
        >
          <el-option
            v-for="item in dictData.dataTypeList"
            :key="item.infoCode"
            :label="item.infoName"
            :value="item.infoCode"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="设备选择" prop="devId">
        <el-select
          v-model="node.elForm.devId"
          placeholder="请选择内容"
          @change="devChange"
          clearable
        >
          <el-option
            v-for="item in devList"
            :key="item.id"
            :label="item.devName"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <span class="remark_span">用来筛选数据选择的下拉</span>
      </el-form-item>

      <el-form-item label="数据选择" prop="dataId">
        <el-select v-model="node.elForm.dataId" placeholder="请选择内容">
          <el-option
            v-for="item in node.elForm.dataType == 0
              ? instantList
              : cumulateList"
            :key="item.id"
            :label="
              node.elForm.dataType == 0 ? item.recordName : item.recordName
            "
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="坐标标记" prop="axisSign">
        <el-select
          v-model="node.elForm.axisSign"
          placeholder="请选择内容"
          clearable
        >
          <el-option
            v-for="item in dictData.axisSignList"
            :key="item.infoCode"
            :label="item.infoName"
            :value="item.infoCode"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="显示颜色" prop="color">
        <el-select
          v-model="node.elForm.color"
          placeholder="请选择内容"
          clearable
        >
          <el-option
            v-for="item in dictData.colorList"
            :key="item.infoCode"
            :label="item.infoName"
            :value="item.infoCode"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="显示类型" prop="type">
        <el-select
          v-model="node.elForm.type"
          placeholder="请选择内容"
          clearable
        >
          <el-option
            v-for="item in dictData.typeList"
            :key="item.infoCode"
            :label="item.infoName"
            :value="item.infoCode"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="最新值显示标记" prop="valDisplay">
        <el-select
          v-model="node.elForm.valDisplay"
          placeholder="请选择内容"
          clearable
        >
          <el-option
            v-for="item in dictData.valDisplay"
            :key="item.infoCode"
            :label="item.infoName"
            :value="item.infoCode"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="描述/备注" prop="remark">
        <el-input
          type="textarea"
          v-model="node.elForm.remark"
          maxlength="100"
          placeholder="请输入内容"
        ></el-input>
        <span class="remark_span">不超过100个字符</span>
      </el-form-item>
      <table class="dialog_table">
        <tr>
          <td>添加用户</td>
          <td>{{ node.elForm.addUser }}</td>
        </tr>
        <tr>
          <td>添加时间</td>
          <td>{{ longToDate(node.elForm.addTime) }}</td>
        </tr>
        <tr>
          <td>最近一次修改用户</td>
          <td>{{ node.elForm.alterUser }}</td>
        </tr>
        <tr>
          <td>最近一次修改时间</td>
          <td>{{ longToDate(node.elForm.alterTime) }}</td>
        </tr>
      </table>
    </el-form>
    <div slot="footer" class="dialog_footer">
      <button class="button_style0" @click="cancelClick">
        <i class="iconfont icon-quxiao1"></i>取消
      </button>
      <button class="button_style0" @click="resetClick">
        <i class="iconfont icon-zhongzhi3"></i>重置
      </button>
    </div>
  </div>
</template>
      
      <script>
import myApi from "@/util/my-api";
import myConst from "@/util/my-const";
import fun from "@/util/util";
export default {
  props: {
    devList: {
      type: Array,
      default: () => {
        [];
      },
    },
    chartData: {
      type: Object,
      default: () => {
        {
        }
      },
    },
    dictData: {
      type: Object,
      default: () => {
        {
        }
      },
    },
    chartDataId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    let testFormula = (rule, value, callback) => {
      if (this.chartData.formula.indexOf(value) == -1) {
        return callback(new Error("请输入公式里的字符"));
      }
      callback();
    };
    return {
      instantList: [], //瞬时量列表
      cumulateList: [], //累积量列表
      comparisonData: {}, //记录查询的单条记录信息
      node: {
        elForm: {
          modelSign: "", //模块标记
          dataType: "", //数据类型
          devId: "", //设备id
          axisSign: "", //坐标标记
          color: "", //颜色
          type: "", //类型
          valDisplay: "", //最新值显示标记
          dataId: "", //数据id
          remark: "", //备注
        },
        rules: {
          // modelSign: [
          //   { required: true, message: "请选择电站", trigger: "change" },
          // ],
          dataType: [
            { required: true, message: "请选择电站", trigger: "change" },
          ],
          // dataId: [
          //   { required: true, message: "请选择电站", trigger: "change" },
          // ],
        },
      },
    };
  },
  computed: {},
  mounted() {},
  methods: {
    //转化日期格式
    longToDate(val) {
      return fun.longToDate(val);
    },
    //设备选择事件
    devChange(id) {
      this.node.elForm.dataId = "";
      if (this.node.elForm.dataType == 0) {
        //如果当前数据类型是瞬时量
        if (fun.isNull(id)) {
          this.loadCurveList("?staId=", this.chartData.staId);
        } else {
          this.loadCurveList("?devId=", id);
        }
      } else if (this.node.elForm.dataType == 1) {
        //如果当前数据类型是累积量
        if (fun.isNull(id)) {
          this.loadCumulateList("?staId=", this.chartData.staId);
        } else {
          this.loadCumulateList("?devId=", this.node.elForm.devId);
        }
      }
    },

    //根据设备id和电站id查询瞬时量
    loadCurveList(str, id) {
      this.$axios.get(myApi.getListBusNew + str + id).then((res) => {
        if (res.data.code === myConst.code.success) {
          this.instantList = res.data.data;
        } else {
          this.instantList = [];
        }
      });
    },

    //根据设备id查询累积量
    loadCumulateList(str, id) {
      this.$axios.get(myApi.getCumulateListBus + str + id).then((res) => {
        if (res.data.code === myConst.code.success) {
          this.cumulateList = res.data.data;
        } else {
          this.cumulateList = [];
        }
      });
    },

    //数据类型选择事件
    dataTypeChange(val) {
      this.node.elForm.dataId = "";
      if (val == 0 && fun.isNull(this.node.elForm.devId)) {
        //如果当前数据类型是瞬时量
        this.loadCurveList("?staId=", this.chartData.staId);
      } else if (val == 1 && fun.isNull(this.node.elForm.devId)) {
        //如果当前数据类型是累积量
        this.loadCumulateList("?staId=", this.chartData.staId);
      } else if (val == 0 && !fun.isNull(this.node.elForm.devId)) {
        this.loadCurveList("?devId=", this.node.elForm.devId);
      } else if (val == 1 && !fun.isNull(this.node.elForm.devId)) {
        this.loadCumulateList("?devId=", this.node.elForm.devId);
      }
    },

    //根据关联id查询单条信息
    getOneInfo(id) {
      if (id) {
        this.$axios
          .get(myApi.getOneChartDataReleInfo + "?id=" + id)
          .then((res) => {
            if (res.data.code === myConst.code.success) {
              this.node.elForm = res.data.data;
              this.node.elForm.modelSign = this.node.elForm.modelSign + "";
              this.node.elForm.dataType = this.node.elForm.dataType + "";
              this.node.elForm.axisSign = this.node.elForm.axisSign + "";
              this.node.elForm.color = this.node.elForm.color + "";
              this.node.elForm.type = this.node.elForm.type + "";
              this.node.elForm.valDisplay = this.node.elForm.valDisplay + "";
              this.getUtils(this.node.elForm.dataType);
              this.comparisonData = JSON.parse(
                JSON.stringify(this.node.elForm)
              );
            } else {
              this.node.elForm = {};
            }
          });
      } else {
        this.node.elForm = {};
      }
    },

    //查瞬狙
    getUtils(val) {
      if (val == 0 && fun.isNull(this.node.elForm.devId)) {
        //如果当前数据类型是瞬时量
        this.loadCurveList("?staId=", this.chartData.staId);
      } else if (val == 1 && fun.isNull(this.node.elForm.devId)) {
        //如果当前数据类型是累积量
        this.loadCumulateList("?staId=", this.chartData.staId);
      } else if (val == 0 && !fun.isNull(this.node.elForm.devId)) {
        this.loadCurveList("?devId=", this.node.elForm.devId);
      } else if (val == 1 && !fun.isNull(this.node.elForm.devId)) {
        this.loadCumulateList("?devId=", this.node.elForm.devId);
      }
    },

    //取消按钮
    cancelClick() {
      this.$emit("closeControlpopover"); //关闭弹窗
    },

    //重置按钮
    resetClick() {
      this.getOneInfo(this.chartDataId);
    },
  },
};
</script>
      
      <style scoped>
.node_add {
  width: 100%;
  height: 100%;
}
.el_from {
  width: 100%;
  height: 92%;
  /* background-color: #fff; */
  overflow: auto;
  position: absolute;
}
::v-deep .el-select,
.el-input,
.el-textarea {
  width: 30rem;
}

::v-deep .el-form-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 15rem;
  box-sizing: border-box;
}

::v-deep .el-form-item__label {
  width: 15rem;
}
.formula {
  color: #fde223;
  font-size: 1.8rem;
}

.dialog_footer {
  position: absolute;
  bottom: 0rem;
  width: 100%;
  display: flex;
  justify-content: center;
}
::v-deep .dialog_table {
  margin-left: 15rem;
  color: #00dafc;
}
</style>